document.addEventListener('turbo:load', function() {
	$(function () {
		/* pageTopBtn */
		$(window).on('load scroll', function () {
			var windowScroll = $(window).scrollTop();
			var windowHeight = window.innerHeight;
			if ($('.js-pagetop').length) {
				var btnStopPos = $('.js-pagetop').offset().top;
			}
			btnStopPos = btnStopPos - windowHeight;
			if (windowScroll > 100) {
				$('.js-pagetop').addClass('view');

				if ((windowScroll > btnStopPos)) {
					$('.js-pagetop').removeClass('fixed');
				} else {
					$('.js-pagetop').addClass('fixed');
				}
			} else {
				$('.js-pagetop').removeClass('fixed');
				$('.js-pagetop').removeClass('view');
			}
		});
		//チェックボックス
		$('.uk-checkbox').on('click', function () {
			$(this).parents('label').toggleClass('uk-active');
		});
		//絞り込み検索reset
		$('.js-clear').on('click', function () { 
			$('.modal-search .uk-checkbox').prop('checked', false);
			$('input[name="client_name"]').val('');
			return false;
		});
		$(document).on("click", ".is-selected-wrap > div", function () {
			$(this).html('');
			var id = $(this).attr('id');
			if (id == 'client_name') {
				$('input[name="client_name"]').val('');
			} else {
				$('input[value="' + id + '"]').prop('checked', false).parents('label').removeClass('uk-active');
			}
			chkSearchChecked();
			return false;
		});
		//絞り込み検索を閉じた時
		UIkit.util.on('#select-jobs,#select-kaihatsu,#select-remote,#select-other', 'hidden', function () {
			chkSearchChecked();
		});
		//絞り込み検索の現在値を表示
		chkSearchChecked();
		function chkSearchChecked() {
			$('.is-selected-wrap').html('');
			$('.is-selected').removeClass('uk-active')
			$('.modal-search .uk-checkbox:checked').each(function () {
				var name = $(this).next('span').html();
				var val = $(this).val();
				var at = $(this).attr('name');
				var html = '<div id="' + val + '"><button type="button" class="uk-button uk-label uk-button-small">' + name + '<i class="uk-icon" uk-icon="close"></i></button><input type="hidden" name="hide_' + at + '" value="' + val + '"></div>';
				$('.is-selected-wrap').append(html);
				$('.is-selected').addClass('uk-active')
			});
			if ($('input[name="client_name"]').val()) {
				var val = $('input[name="client_name"]').val();
				var html = '<div id="client_name"><button type="button" class="uk-button uk-label uk-button-small">' + val + '<i class="uk-icon" uk-icon="close"></i></button><input type="hidden" name="hide_client_name" value="' + val + '"></div>';
				$('.is-selected').addClass('uk-active');
				$('.is-selected-wrap').append(html);
			}
		}

		// Remoguキャリアリダイレクトをキャンセルする場合の処理
		$('.cancel-redirect').on('click', function () {
			window.cancelRedirect = true;
		});
	});
	//横幅リサイズ時の処理
	var timer = false;
	var prewidth = $(window).width();
	if (prewidth < 480) {
		new ScrollHint('.js-scrollable');
		//UIkit.slider('.js-scrollable');
	}
	$(window).resize(function () {
		if (timer !== false) {
			clearTimeout(timer);
		}
		timer = setTimeout(function () {
			var nowWidth = $(window).width();
			if (prewidth !== nowWidth) {
				//リサイズしたらスタートに戻る
				UIkit.slider('.jobsliders').show(0);
			}
			if (nowWidth < 480) {
				new ScrollHint('.js-scrollable');
				//UIkit.slider('.js-scrollable');
				//UIkit.slider('.js-scrollable').show(0);
			}
			prewidth = nowWidth;
		}, 200);
	});
});